import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-#",
  "use": "icon-#-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-#\">\n<g id=\"icon-#_&#231;&#149;&#170;&#229;&#143;&#183;\">\n<path id=\"icon-#_Vector 56\" d=\"M3.4 5.5H10.6M7 3L5.8 10.5M5.4 13L5.8 10.5M11 3L9.4 13M3 10.5H5.8M7.4 10.5H12.6M12.6 5.5H13\" stroke=\"#666666\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol